/**
 * BuyCreditsButton Component
 * Credit balance pill for the header — visible on mobile only (sidebar handles desktop)
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Coins } from 'lucide-react';
import { useCreditBalance } from '@/hooks/useCredits';
import { BuyCreditsDialog } from '@/components/credits/BuyCreditsDialog';
import { cn } from '@/lib/utils';

export function BuyCreditsButton() {
  const { t } = useTranslation();
  const { data: balance, isLoading } = useCreditBalance();
  const [open, setOpen] = useState(false);

  const credits = balance?.credits ?? 0;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className={cn(
          'flex items-center gap-1.5 pl-2 pr-2.5 py-1 rounded-full',
          'border border-[var(--color-primary-start)]/15',
          'bg-gradient-to-r from-[var(--color-primary-start)]/[0.04] to-[var(--color-primary-end)]/[0.06]',
          'hover:from-[var(--color-primary-start)]/[0.08] hover:to-[var(--color-primary-end)]/[0.10]',
          'transition-all cursor-pointer',
          'md:hidden'
        )}
        aria-label={t('credits.buttonAriaLabel')}
      >
        <Coins className="h-3.5 w-3.5 text-[var(--color-primary-start)]" />
        <span className={cn(
          'text-xs font-semibold tabular-nums',
          isLoading ? 'text-gray-300' : 'text-[var(--color-charcoal)]'
        )}>
          {isLoading ? '–' : credits}
        </span>
      </button>

      <BuyCreditsDialog isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
}
